<div class="configuration-modal flex flex-col h-full">

    <h2 mat-dialog-title>Configuration de l'éligibilité commerciale</h2>
    
    <mat-dialog-content>
        <div class="flex flex-col h-full">

            <div class="config-tab flex flex-row">
                <div class="config-tab flex flex-col h-full gap-2">
                    <div class="flex flex-row w-full items-center pr-2">
                        <h3 class="text-lg font-medium">Typologies de site</h3>
                        <div class="spacer"></div>
                        <i class="arrow right mr-4"></i>
                    </div>
                    <div class="flex flex-row items-center">
                        <button 
                            class="icon-stroked-button" 
                            mat-stroked-button>
                            <mat-icon>add</mat-icon> Ajouter une typologie de site
                        </button>
                    </div>
                    <ag-grid-angular
                        class="pr-4 mt-2 grid-dimensions"
                        [columnDefs]="columns"
                        [rowData]="rowData()"
                        [autoSizeStrategy]="{type: 'fitGridWidth'}"
                        [rowSelection]="gridRowSelection"
                        (rowSelected)="selectSiteTypology($event)"
                    />
                </div>
                <div class="config-tab flex flex-col h-full gap-2">
                    <div class="flex flex-row w-full items-center pr-2">
                        <h3 class="text-lg font-medium">Accès</h3>
                        <div class="spacer"></div>
                        <i class="arrow right mr-4"></i>
                    </div>
                    <div class="flex flex-row items-center">
                        <button 
                            class="icon-stroked-button" 
                            mat-stroked-button
                            [disabled]="!selectedSiteTypology()">
                            <mat-icon>add</mat-icon> Ajouter un accès
                        </button>
                    </div>
                    <ag-grid-angular
                        class="pr-4 mt-2 grid-dimensions"
                        [columnDefs]="columns"
                        [rowData]="selectedSiteTypology()?.accesses"
                        [autoSizeStrategy]="{type: 'fitGridWidth'}"
                        [rowSelection]="gridRowSelection"
                        [loadingOverlayComponent]="loadingOverlayComponentAccess"
                        [loadingOverlayComponentParams]="loadingOverlayComponentAccessParams"
                        (rowSelected)="selectAccess($event)"
                    />
                </div>
                <div class="config-tab flex flex-col h-full gap-2">
                    <div class="flex flex-row w-full items-center">
                        <h3 class="text-lg font-medium">Technologies</h3>
                    </div>
                    <div class="flex flex-row items-center">
                        <button 
                            class="icon-stroked-button" 
                            mat-stroked-button
                            [disabled]="!selectedAccess()"
                            (click)="addTechnology()">
                            <mat-icon>add</mat-icon> Ajouter une technologie
                        </button>
                    </div>
                    <!-- <ng-select
                        class="mt-2"
                        bindLabel="name"
                        [clearable]="true"
                        [(ngModel)]="toBeAddedTechnology"
                        [placeholder]="'Sélectionner une technologie à prioriser'"
                        [items]="[
                            {name: 'FTTO', technology: 'FTTO', provider: 'Orange', offer: 'Access'}, 
                            {name: 'FTTE', technology: 'FTTE', provider: 'Orange', offer: 'Access'}, 
                            {name: 'FTTH', technology: 'FTTH', provider: 'Covage', offer: 'BPE'}
                        ]">
                    </ng-select>
                    <button class="mt-2" mat-stroked-button [disabled]="!selectedAccess() || !toBeAddedTechnology()" (click)="addTechnology()">Ajouter</button> -->
                    <ag-grid-angular
                        class="mt-2 grid-dimensions"
                        [columnDefs]="technologyColumns"
                        [rowData]="technologiesList()"
                        [rowDragManaged]="true"
                        [autoSizeStrategy]="{type: 'fitGridWidth'}"
                        [rowSelection]="gridRowSelection"
                        [loadingOverlayComponent]="loadingOverlayComponentOffers"
                        [loadingOverlayComponentParams]="loadingOverlayComponentOffersParams"
                    />
                </div>
            </div>
        </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
        <button mat-stroked-button [mat-dialog-close]>Annuler</button>
        <button mat-stroked-button>Réinitialiser</button>
        <button mat-stroked-button>Sauvegarder</button>
    </mat-dialog-actions>
    
    

</div>    
